import { InjectionToken } from "@angular/core";
import { IWelcomeWizardModalService } from "./i-welcome-wizard-modal.service";

export const welcomeWizardModalServiceInjectionToken = new InjectionToken<IWelcomeWizardModalService>("welcomeWizardModalService");
